import { ChartMode, ScoreDetailChartData } from "./chart.types";
import { ComparisonChart } from "./Comparison/ComparisonChart";
import { DistributionChart } from "./Distribution/DistributionChart";
import { EvolutionChart2 } from "./EvolutionChart";

type ScoreDetailChartBoxProps = {
    mode: ChartMode;
    total: ScoreDetailChartData | null;
    data: ScoreDetailChartData[];
};
export const ScoreDetailChartBox = (props: ScoreDetailChartBoxProps) => {
    const { mode, total, data } = props;

    if (mode === "distribution") {
        return <DistributionChart total={total} data={data} />;
    }

    if (mode === "comparison") {
        return <ComparisonChart total={total} data={data} />;
    }

    if (mode === "evolution") {
        // It's called 2 but it's not used right now
        return <EvolutionChart2 total={total} data={data} />;
    }

    // Will throw type error is ChartMode case is not handled properly
    const _d: never = mode;
};
